import { render, staticRenderFns } from "./ViewVisaRequest.vue?vue&type=template&id=61d0dcc4&scoped=true&"
import script from "./ViewVisaRequest.vue?vue&type=script&lang=js&"
export * from "./ViewVisaRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0dcc4",
  null
  
)

export default component.exports